<div class="container mt-5">
    <div class="row">
        <div class="col-md-5">
            <div class="bg-light p-4">
                <h2 class="mb-4">Resumen de la compra</h2>
                
                <div class="mb-3">
                    <label class="fw-bold">Cliente:</label>
                    <div>{{nombreCliente}}</div>
                </div>

                <div class="row mb-3">
                    <div class="col-6">
                        <label class="fw-bold">RUT:</label>
                        <div>{{rut}}</div>
                    </div>
                    <div class="col-6">
                        <label class="fw-bold">Email:</label>
                        <div>{{email}}</div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-6">
                        <label class="fw-bold">Tipo de compra:</label>
                        <div>{{tipoCompra}}</div>
                    </div>
                    <div class="col-6">
                        <label class="fw-bold">Tipo de documento:</label>
                        <div>{{tipoDocumento}}</div>
                    </div>
                </div>

                <div class="mb-4">
                    <label class="fw-bold">Origen:</label>
                    <div>{{origen}}</div>
                </div>

                <div class="border-top pt-3">
                    <div class="d-flex justify-content-between mb-2">
                        <span>Subtotal</span>
                        <span>${{subtotal | thousandSeparator}}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-3" *ngIf="intereses && intereses !== 0">
                        <span>Intereses</span>
                        <span>${{intereses | thousandSeparator}}</span>
                    </div>
                    <div class="d-flex justify-content-between fw-bold">
                        <span>Total</span>
                        <span class="h4 mb-0">${{total | thousandSeparator}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-7">
            <h2 class="mb-3">Selecciona tu medio de Pago</h2>
            <p class="text-muted mb-4">Puedes pagar con tus tarjetas de crédito o débito, o transferencia bancaria.</p>

            <div class="alert alert-info d-flex align-items-center mb-4">
                <img [src]="pathClock" alt="clock" height="20">
                Estimado cliente, tiene {{segundos}} segundos para iniciar un pago
            </div>

            <div class="mb-3">
                <label class="mb-2">Selecciona tu opción de pago:</label>
                
                <div class="card mb-3" *ngFor="let medio of mediosPago">
                    <div class="card-body d-flex justify-content-between align-items-center">
                        <div class="form-check">
                            <input class="form-check-input" 
                                   type="radio" 
                                   [name]="'medioPago'"
                                   [id]="medio.id"
                                   [value]="medio.id"
                                   [(ngModel)]="medioPagoSeleccionado">
                            <label class="form-check-label" [for]="medio.id">
                                {{medio.nombre}}
                            </label>
                        </div>
                        <img [src]="medio.imagen" [alt]="medio.nombre" height="40">
                    </div>
                </div>

                <button class="btn btn-primary w-100 py-3" (click)="pagar()">
                    Pagar: ${{total | thousandSeparator}}
                </button>

                <p class="text-muted small mt-3">
                    Los datos personales proporcionados serán utilizados exclusivamente para procesar su pedido, mejorar su experiencia en este sitio web y para otros fines estipulados en nuestra política de privacidad.
                </p>
            </div>
        </div>
    </div>
</div>
<!-- Modal de Bootstrap para timeout -->
<div class="modal fade" id="timeoutModal" tabindex="-1" aria-labelledby="timeoutModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" [style.display]="mostrarModalTimeout ? 'block' : 'none'">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" style="background-color: black;color: white;">
                <h5 class="modal-title" style="color: white;" id="timeoutModalLabel">
                    <i class="fas fa-clock me-2"></i>Tiempo Agotado
                </h5>
            </div>
            <div class="modal-body text-center">
                <div class="mb-3">
                    <i class="fas fa-exclamation-triangle text-warning" style="font-size: 3rem;"></i>
                </div>
                <h6 class="mb-3">El tiempo para realizar el pago ha expirado</h6>
            </div>
            <div class="modal-footer justify-content-center">
                <button k-button class="btn btn-primary" style="margin-top: 10px;margin-bottom: 10px;" (click)="cerrarModalYRedirigir()">
                    <i class="icon-arrow-right"></i>
                    Continuar
                </button>
            </div>
        </div>
    </div>
</div>

<div [className]="cargando ? 'fondooscuro':'oculta'">
    <div [className]="cargando ? 'fondooscuro':'oculta'"></div>
    <div [className]="cargando ? 'contenedormodal':'oculta'">
        <k-loader [color]="color" [size]="size"></k-loader>
        <p class="mt-3">Estamos procesando tu solicitud {{punto}}</p>
    </div>
</div>
